module.exports = __webpack_public_path__ + "static/media/rookie.9cba70c1.svg";